function PulseAnimation() {
  return (
    <span className="flex gap-1.5">
      <span className="scale-0.5 size-4 animate-[1.5s_linear_0s_pulse-loading-animation_infinite] rounded-full bg-loading-animation-surface" />
      <span className="scale-0.75 size-4 animate-[1.5s_linear_0.5s_pulse-loading-animation_infinite] rounded-full bg-loading-animation-surface" />
      <span className="size-4 scale-100 animate-[1.5s_linear_1s_pulse-loading-animation_infinite] rounded-full bg-loading-animation-surface" />
    </span>
  )
}

export { PulseAnimation }
